import { useEffect } from "react";

export const PAGE_BG = "#F8F6F0";

export function usePageBackground(color: string = PAGE_BG) {
  useEffect(() => {
    const prev = document.body.style.getPropertyValue("background-color");
    const prevPriority = document.body.style.getPropertyPriority("background-color");
    document.body.style.setProperty("background-color", color, "important");
    return () => {
      if (prev) document.body.style.setProperty("background-color", prev, prevPriority);
      else document.body.style.removeProperty("background-color");
    };
  }, [color]);
}
